<template>
<div class="container-fluid" >
 <waitingModal v-if="waitModal.show == true" @close="closeWaitingModal()"  v-bind:props="waitModal" ></waitingModal>
 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4 ><i style="color:yellow" class="fas fa-donate mr-3" aria-hidden="true"></i>ANALISI VENDITE</h4>
  </div> 

 <div  class="card-body"> 
  <p v-if="1== 0">
      Sede <strong>{{title.store}}</strong> - Fornitore  <strong>{{title.supplier}}</strong> - Stagione <strong>{{title.season}}</strong> - Anno  <strong>{{title.season_year}}</strong>     - Reparto <strong>{{title.department}}</strong> - Gruppo Categoria <strong>{{title.catGrouping}}</strong> - MARKET <strong>{{title.market}}</strong>
  </p>
  <div class="row">
  <div v-if="type==''"  class="col"> 

  <div class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">


  <form name="filter" v-on:submit.prevent="submit()">

    <div class="form-row">
    <div class="col-md-4">
      <label for="date_doc"><strong>DA DATA VENDITA </strong></label>
      <input  required v-model="data1" type="date" class="form-control" placeholder="" >        
    </div>
    <div class="col-md-4">
    <label for="date_doc"><strong>A DATA VENDITA </strong></label>
    <input required v-model="data2" type="date" class="form-control" placeholder="" >              
    </div>
    
    <div class="col-md-4">
    <!--  <store-select v-bind:props="store"  @update="setStoreId"></store-select> -->
      <store-vue-select  @update="setStoreId" v-bind:props="store"></store-vue-select>
    </div>

    </div>
    <div class="form-row">
    <div class="col-md-3">
      <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>
    </div>
    <div class="col-md-2">
      <season-select v-bind:props="season" @update="setSeasonId"></season-select>                
    </div>
    <div class="col-md-2">
      <year-select  v-bind:props="season_year" @update="setYear"></year-select>
    </div>
    <div class="col-md-2">
      <department-select v-bind:props="department" @update="setDepartmentId"></department-select>
    </div>
    <div class="col-md-3">
      <category-grouping v-bind:props="catGrouping" @update="setGroupCategoryId"></category-grouping>
    </div>
    </div>
        

 <!--   
  </div>  -->


<span><strong>PROVENIENZA VENDITA</strong></span>
<div  v-for="(item,index) in salesFrom" :key="index">  
      <div class="form-check">
        <input type="radio" class="form-check-input" :id="'typeId_' + index" :value="index" v-model="typeId">
        <label class="form-check-label"  :for="'typeId_' + index">{{item.description}}</label>
      </div>
</div>  


<mp-select v-if="typeId==1" class="mt-2 mb-4" v-bind:props="market" @update="setMPId"></mp-select>
<hr>
<span><strong class="mt-4 mr-3">TIPO ANALISI</strong></span>
<div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios0" id="exampleRadios0" value="0"  v-model="dataType" checked>
  <label class="form-check-label" for="exampleRadios0">
    ANALITICA PER PRODOTTO/VARIANTE
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios2" id="exampleRadios1" value="1" v-model="dataType">
  <label class="form-check-label" for="exampleRadios1">
    SINTETICA PER STAGIONE E REPARTO
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios2" id="exampleRadios2" value="2" v-model="dataType">
  <label class="form-check-label" for="exampleRadios2">
    SINTETICA PER GIORNO DEL MESE
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios3" id="exampleRadios3" value="3" v-model="dataType">
  <label class="form-check-label" for="exampleRadios3">
    SINTETICA PER BRAND
  </label>
</div>

<div class="card-footer bg-transparent border-info mt-2">
  <button :disabled="spinner" type="submit"  class="btn btn-primary ">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI
      <!--<span v-if="spinner" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>-->
     </button>        
     

</div>
<alert-box style="margin-top:10px" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

</form>



</div>
</div>
</div>

<!--COL 2 -->
<div v-else class="col" >
 

  <div v-if="type=='A'">
    <productsList   v-bind:items="items" v-bind:totals="totals" v-bind:pdf="{'date1':data1,'date2':data2}"   @close="type=''"> </productsList> 
  </div>

  <div v-if="type=='B'">
    <productsGrouped1  v-bind:items="items"  @close="type=''" v-bind:pdf="{'date1':data1,'date2':data2}"> </productsGrouped1> 
  </div>

  <div v-if="type == 'C'">
    <productsGrouped2  v-bind:items="items"  @close="type=''" v-bind:pdf="{'date1':data1,'date2':data2}"> </productsGrouped2> 
  </div>
  <div v-if="type == 'D'">
    <brandSales  v-bind:items="items"  @close="type=''"> </brandSales> 
  </div>
 
</div>  
</div>
</div>
</div>

</div>

</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import supplierSelect    from '@/components/common/SupplierSelect_1.vue'
import seasonSelect      from '@/components/common/SeasonSelect_1.vue'

import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'
import categoryGrouping   from '@/components/common/CategoryGroupingSelect_1.vue'
import storeSelect       from '@/components/common/StoreSelect_1.vue'
import mpSelect          from '@/components/common/MPSelect.vue'

import fmt               from '@/components/mixins/fmt'
import yearSelect        from '@/components/common/YearSelect_1.vue'
import productsList      from '@/components/stat/SalesProducts.vue'
import productsGrouped1  from '@/components/stat/SalesProductsGroupedbySeason.vue'
import productsGrouped2  from '@/components/stat/SalesProductsGroupedbyDayOfWeek.vue'
import brandSales        from '@/components/stat/BrandSales.vue'
import waitingModal      from "@/components/common/WaitingModal.vue"
import storeVueSelect    from '@/components/common/StoreVueSelect.vue'


export default {
  mixins     : [fmt],
  components : {alertBox,departmentSelect,storeSelect,supplierSelect,seasonSelect,categoryGrouping,mpSelect,yearSelect,productsList,productsGrouped1,productsGrouped2,brandSales,waitingModal,storeVueSelect},
  data() {
    return {
      
      waitModal    : {

          sentinel   : 0,
          show       : false,
          msg1       : 'ELABORAZIONE IN CORSO ...',
          msg2       : '' 

      },
      dataType        : 0,
      salesFrom       : [{'typeId':0,'description': 'RETAIL'},{'typeId':1 ,'description':'ONLINE'}],
      typeId          : 0,
      type            : '',
     
      title           : {store : 'Tutte',department:'Tutti',season:'Tutte',supplier : 'Tutti',catGrouping : 'Tutti',market :'Tutti','season_year':'Tutti'},

      market          :
      {
        Id            : 0,
        disabled      : false,
       
        optionBase    : true,
        required      : false
      },
      supplier        : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : true

      },
      store             : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false,
        Ids           : '',
        selection     : [],
      },
      season          : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : true

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },
      catGrouping     : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },


      data1           : new Date().toISOString().slice(0,10),
      data2           : new Date().toISOString().slice(0,10),
      
     

      alert           : false, 
      spinner         : false,
      spinner_pdf     : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      totals          : [],
      /*avg             : {},*/
      row_total       : [],
      spinnerCSV      : false
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    //this.getGrouping()
  },
  methods: {
  
  closeWaitingModal()
  {
    this.waitModal.show = false
    this.waitModal.sentinel = 0
      
  }, 
   
  setMPId(Id,e)
    {
      this.market.Id = Id
      this.title.market = e.target.options[e.target.options.selectedIndex].text  
      if(Id == 0)
      {this.title.market = 'Tutti'}    
    },  

  
    setSupplierId(Id,text)
    {
        this.supplier.Id = Id
        this.title.supplier = text  
        if(Id == 0)
        {
           this.title.supplier = 'Tutti'
        }
        
        
    },  
    setDepartmentId(Id,e)
    {
      this.department.Id = Id
      this.title.department = e.target.options[e.target.options.selectedIndex].text  
      if(Id == 0)
        {
           this.title.department = 'Tutti'
        }

    },
    setSeasonId(Id,e)
    {           
        this.season.Id = Id
        this.title.season = e.target.options[e.target.options.selectedIndex].text  
        if(Id == 0)
        {
           this.title.season = 'Tutte'
        }
    },  
    setYear(year,e)
    {
      this.season_year.year = year
      this.title.season_year = e.target.options[e.target.options.selectedIndex].text  
      
      if(year == 0)
      {
        this.title.season_year = 'Tutti'
      }
    },

    setStoreId(Ids)
    {
      this.store.selection = Ids
      let storeIds = ''
      if (Ids.length > 0)
      {
        storeIds = Ids.join() 
      }
       
      this.store.Ids = storeIds
     
      /*this.store.Id = Id
      this.title.store = e.target.options[e.target.options.selectedIndex].text  
      if(Id == 0)
      {
        this.title.store = 'Tutte'
      }
      */
      
    },
    setGroupCategoryId(Id,e)
    {
      this.catGrouping.Id = Id
      this.title.catGrouping = e.target.options[e.target.options.selectedIndex].text  
      if(Id == 0)
      {
        this.title.catGrouping = 'Tutti'
      }

    },
    submit() 
    {
      this.getData()
    },  
    
    

    async getData() {
      
      this.row_total = []
      this.items = []
                  
      this.msg.title = ''  
      let sp = {}
      if(this.dataType == 0)
      {
        sp =   {'sp' : 'spSalesProductsAnalisys'} 
      }
      else if(this.dataType == 1)
      {
        sp =   {'sp' : 'spSalesAnalisysGroupedPDF'} 
      }
      else if(this.dataType == 2)
      {
        sp = {'sp' : 'spSalesAnalisysGroupedByDayOfMonth'}   
      }
      else if(this.dataType == 3)
      {
        sp = {'sp' : 'spStoreSales'}   
      }
      const data  = {

          'companyId'   : this.company.Id,
          'data1'       : this.data1,
          'data2'       : this.data2,
          'storeId'     : this.store.Id,
          'catParentId' : this.catGrouping.Id,
          'departmentId': this.department.Id,
          'supplierId'  : this.supplier.Id,
          'seasonId'    : this.season.Id,
           'mpId'       : this.market.Id,
          'season_year' : this.season_year.year,
          'typeId'      : this.typeId,
          'storeIds'    : this.store.Ids
      }
      
      const json  = Object.assign(data, sp)
            
      this.spinner = true
      this.waitModal.show = true

      await api.post(json).then(res => {
         
          if(res.status==200)
            {
             
              // Return Status 
              if(res.data.recordsets.length > 0)
              {
                  this.waitModal.sentinel = 1
                  if(res.data.recordsets[0].length > 0 &&  res.data.recordsets[0][0].ReturnStatus)
                  {
                  
                  const dd = 31 * res.data.recordsets[0][0].ReturnStatus 
                  
                  this.msg.title = 'ATTENZIONE '
                  this.msg.body  = ' IL PERIODO DI VENDITA NON DEVE ESSERE SUPERIORE AI ' +  dd + ' GIORNI .'
                  this.msg.type  = 1

                  return
                }
              }

              this.items = res.data.recordsets[0]
             
              if(this.items.length==0)
              {
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
                return
              }

              
              if(this.dataType ==0)
              {
                this.totals = []
              
                this.totals.push(res.data.recordsets[1])
                this.totals.push(res.data.recordsets[2])

                if(this.typeId == 1)
                {
                  this.totals.push(res.data.recordsets[3])
                }
                else
                {
                  this.totals.push([])
                }
                this.type = 'A'
              }
              else if(this.dataType == 1)
              {
                this.type = 'B'
              }
              else if(this.dataType == 2)
              {
                this.type = 'C'
              }
              else if(this.dataType == 3)
              {
                
                this.type = 'D'
              }          

            }
            else if (res.status==500)
            {
              
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            
            this.waitModal.sentinel = 2
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            this.waitModal.sentinel = 3
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      


    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 800px;
overflow   : auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 25px;
    background   :#e9fce9;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.grp{
  font-size    : 18px;
  color        : darkmagenta;
}
.form-check-label{
  cursor:pointer
}
.custom-control-label
{
  cursor:pointer
}
.btn-export
{
  background-color: saddlebrown;
  color           :whitesmoke
}
.card-header
{
  height: 50px;
}
</style>